import {
  Typography,
  Card,
  CardHeader,
  CardContent,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Grid,
  Link as MuiLink,
} from '@material-ui/core';
import { ExpandMore, NotificationsNoneRounded } from '@material-ui/icons';

import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useAptorApi } from '../../../../Api';
import { Loading, HtmlView } from '../../../../Components';
import { debug } from 'console';

interface IInformationBoard {
  id: number;
  headline: string;
  message: string;
  url?: string;
  urlName?: string;
  visibleTo?: number;
  status?: boolean;
  createdAt?: string;
  createdBy?: number;
  isRead?: boolean;
}

export const InformationBoardWidget = () => {
  const { formatMessage } = useIntl();
  const { api, abortController } = useAptorApi();
  const [expendedItem, setExpanded] = useState<any[]>([]);
  const [informationBoard, setInformationBoard] = useState<IInformationBoard[]>();

  useEffect(() => {
    getData();
  }, [api, abortController]);
const getData=()=>{
      api.getDashboardAnnouncements<IInformationBoard>().then((result: any) => {
      if (abortController.current.signal.aborted) {
        return;
      }
      setInformationBoard(result);
    });
}
  const handleExpand = (announcement,expended) => {
    if (expended&&!announcement.isRead) {
      api.markAnnouncementRead(announcement.id).then((result: any) => {
        setExpanded([...expendedItem, announcement.id])
        getData();
      if (abortController.current.signal.aborted) {
        return;
      }
    });
    }else{
      let filtered = expendedItem.filter((item) => item != announcement.id)
      setExpanded(filtered)
    }
  };
  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h3">
            <FormattedMessage id="law-portal.dashboard.informationBoard" />
          </Typography>
        }
      />
      <CardContent style={{ padding: '10px 40px' }}>
        {(informationBoard === undefined && <Loading />) || (
          informationBoard?.map((item, index) => (
            <ExpansionPanel key={item.id} style={{ marginBottom: '10px' }} defaultExpanded={expendedItem.includes(item.id)} onChange={(event,expended)=>handleExpand(item,expended)}>
              <ExpansionPanelSummary expandIcon={<ExpandMore />} >
                <Typography variant="h6" style={{ display: 'flex', alignItems: "center", gap: "7px" }}>{item.headline} {!item?.isRead && <NotificationsNoneRounded color='primary' />}</Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <Grid container direction="column" style={{ width: '100%' }}>
                  <Grid item>
                    <HtmlView variant="body2" value={item.message} />
                  </Grid>
                  <Grid item>
                    <MuiLink href={item.url} target="_blank" rel="noopener noreferrer">
                      {item.urlName || formatMessage({ id: "admin.law-portal.informationboard.form.urlName.placeholder" })}
                    </MuiLink>
                  </Grid>
                </Grid>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          ))
        )}

      </CardContent>
    </Card>
  );
};
